export const apiResponseEnum = {
    SUCCESS: "ALERT_SUCCESS",
    ERROR: "ALERT_ERROR",
    CLEAR: "ALERT_CLEAR",
    SOMETHING_WRONG: "Something went wrong",
    INTERNET_DISCONNECTED: "INTERNET DISCONNECTED"
};